import {call, put, takeEvery} from 'redux-saga/effects';
import {Actions, ACTION_TYPES} from './types';
import AuthService from '../../services/auth';

export function* loginUser(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            AuthService.login.bind(AuthService),
            payload.username,
            payload.password,
        );
        yield put({
            type: ACTION_TYPES.LOGIN_SUCCESS,
            payload: result,
        });
    } catch (err) {
        yield put({
            type: ACTION_TYPES.LOGIN_ERROR,
            payload: null,
        });
    }
    return null;
}

export function* registerUser(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            AuthService.register.bind(AuthService),
            payload
        )
        yield put({
            type: ACTION_TYPES.LOGIN_SUCCESS,
            payload: result,
        });
    } catch (err) {}

}

export function* logout(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            AuthService.logout.bind(AuthService),
        );
    } catch (err) {}

}

const userSaga = [
    takeEvery(ACTION_TYPES.LOGIN, loginUser),
    takeEvery(ACTION_TYPES.REGISTER, registerUser),
    takeEvery(ACTION_TYPES.LOGOUT, logout),
];

export default userSaga;
